import { makeReg3 } from './textStyles';
export const makeFilledInputStyle = (tokens) => makeReg3(tokens, {
    paddingLeft: tokens.Spacing05,
    paddingRight: tokens.Spacing05,
    paddingTop: tokens.Spacing04,
    paddingBottom: tokens.Spacing04,
    borderWidth: tokens.BorderWidth01,
    borderRadius: tokens.BorderRadius02,
    backgroundColor: tokens.Grey200,
    borderColor: tokens.BorderLight500,
    h: '48px',
    textColor: tokens.TextLight500,
    w: '340px',
    _hover: {
        background: tokens.Layer01,
        borderColor: tokens.BorderLight500,
    },
    _placeholder: {
        color: tokens.TextLight500,
    },
    _focus: {
        color: tokens.TextMedium600,
        outlineColor: tokens.BorderFocus,
        outlineWidth: tokens.BorderWidth02,
        borderColor: tokens.BorderDark800,
        bgColor: tokens.Layer01,
        background: tokens.Layer01,
    },
    _disabled: {
        borderColor: tokens.BorderLight500,
    },
    _active: {
        textColor: tokens.TextBlack800,
        borderColor: tokens.BorderDark800,
    },
    _focusVisible: {
        shadow: 'none',
    },
    _invalid: {
        borderWidth: tokens.BorderWidth02,
        borderColor: tokens.BorderError,
    },
});
const inputStyles = (tokens) => ({
    variants: {
        filled: {
            field: makeFilledInputStyle(tokens),
        },
        primary: {
            field: makeReg3(tokens, {
                paddingLeft: tokens.Spacing05,
                paddingRight: tokens.Spacing05,
                paddingTop: tokens.Spacing04,
                paddingBottom: tokens.Spacing04,
                borderWidth: tokens.BorderWidth01,
                borderRadius: tokens.BorderRadius02,
                backgroundColor: tokens.Grey200,
                borderColor: tokens.BorderLight500,
                _placeholder: {
                    color: tokens.Neutral500,
                },
                _focus: {
                    outlineColor: tokens.BorderFocus,
                    outlineWidth: tokens.BorderWidth02,
                    borderColor: tokens.BorderDark800,
                    bgColor: tokens.Layer01,
                    background: tokens.Layer01,
                },
            }),
        },
        search: {
            field: {
                background: tokens.Layer02,
                borderWidth: tokens.BorderWidth01,
                borderColor: tokens.BorderLight500,
                borderRadius: tokens.BorderRadius02,
                bg: tokens.Layer02,
                color: tokens.TextLight500,
                fontSize: tokens.TextBodyReg3FontSize,
                lineHeight: tokens.TextBodyReg3LineHeight,
                width: '400px',
                _placeholder: {
                    color: tokens.TextLight500,
                },
                _focus: {
                    color: tokens.TextMedium600,
                    outlineColor: tokens.BorderFocus,
                    outlineWidth: tokens.BorderWidth02,
                    borderColor: tokens.BorderDark800,
                    bgColor: tokens.Layer01,
                    background: tokens.Layer01,
                },
            },
        },
    },
});
export default inputStyles;
